import config from "../../shared/config/config";
import axios from "../../shared/utils/axios";
import axiosBlob from "../../shared/utils/axiosBlob";
import { LogItem } from "../../types/files";
import {
  LogDTO,
  LogList,
  SummaryLogDTO,
  SummaryLogItem,
} from "../../types/log";

const GATEWAY_URL = config.servers.gateway.url;

interface LogApi {
  newLogList(logDTO: LogDTO): Promise<LogList>;
  getSummaryLogList(logDTO: SummaryLogDTO): Promise<SummaryLogItem[]>;
  getLogDetail(req: { logIdList: string[] }): Promise<LogList>;
  getDocUserLog(logSearchOptions: LogDTO): Promise<LogList>;
  getDocUserLogExcel(logSearchOptions: LogDTO): Promise<any>;
}

class LogServerApi implements LogApi {
  async newLogList(logDTO: LogDTO): Promise<LogList> {
    const resp = await axios.post<LogList>(
      `${GATEWAY_URL}/wapi/logs/new/paging`,
      logDTO
    );
    return Promise.resolve(resp.data);
  }
  async getSummaryLogList(logDTO: SummaryLogDTO): Promise<SummaryLogItem[]> {
    const resp = await axios.post<SummaryLogItem[]>(
      `${GATEWAY_URL}/wapi/logs/summary`,
      { ...logDTO, timezoneOffset: new Date().getTimezoneOffset() }
    );
    return Promise.resolve(resp.data);
  }
  async getLogDetail(req: { logIdList: string[] }): Promise<LogList> {
    const resp = await axios.post<LogList>(
      `${GATEWAY_URL}/wapi/logs/detail`,
      req
    );
    return Promise.resolve(resp.data);
  }
  async getDocUserLog(logSearchOptions: LogDTO): Promise<LogList> {
    const resp = await axios.post<LogList>(
      `${GATEWAY_URL}/wapi/logs/new/paging/contents/me`,
      {
        ...logSearchOptions,
        workgroupCategoryList: ["GENERAL", "PRIVATE"],
        filterDocument: logSearchOptions.filterDocument?.includes(7)
          ? [...(logSearchOptions.filterDocument ?? []), 12]
          : logSearchOptions.filterDocument,
      }
    );
    return Promise.resolve(resp.data);
  }
  async getDocUserLogExcel(logSearchOptions: LogDTO): Promise<any> {
    try {
      const resp = await axiosBlob.post<LogList>(
        `${GATEWAY_URL}/wapi/logs/new/paging/contents/me/excel`,
        {
          ...logSearchOptions,
          workgroupCategoryList: ["GENERAL", "PRIVATE"],
          filterDocument: logSearchOptions.filterDocument?.includes(7)
            ? [...(logSearchOptions.filterDocument ?? []), 12]
            : logSearchOptions.filterDocument,
        }
      );
      return Promise.resolve({ data: resp.data, headers: resp.headers });
    } catch (error) {
      return Promise.resolve({ error: error });
    }
  }
}
const logApi: LogApi = new LogServerApi();
export default logApi;
